module.exports = __webpack_public_path__ + "static/media/cc-logo.b9830783.svg";